<template>
  <div class="side-menu">
    <div
      v-for="(menu, index) in menuList"
      :key="index"
      class="main-menu-wrapper"
    >
      <div class="main-menu">
        <span class="menu-title">{{ menu.title }}</span>
      </div>
      <div
        v-for="(subMenu, subIndex) in menu.subMenus"
        :key="subIndex"
        class="sub-menu"
        :class="{ active: isActive(subMenu) }"
        @click="handleSubMenuClick(subMenu)"
      >
        <span class="sub-menu-title">{{ subMenu.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  data() {
    return {
      menuList: [
        {
          title: '注册使用',
          subMenus: [
            {
              title: '注册使用',
              router: '/help/registerUse',
            },
          ],
        },
        {
          title: '互动功能',
          subMenus: [
            {
              title: '礼物上墙',
              router: '/help/giftWall',
            },
            {
              title: '霸屏',
              router: '/help/fullscreen',
            },
            {
              title: '点歌',
              router: '/help/songRequest',
            },
            {
              title: '打赏',
              router: '/help/reward',
            },
            {
              title: '抽奖',
              router: '/help/lottery',
            },
          ],
        },
        {
          title: '互动游戏',
          subMenus: [
            {
              title: '点数风暴',
              router: '/help/diceStorm',
            },
            {
              title: '荭包雨',
              router: '/help/redPacketRain',
            },
            {
              title: '摇一摇游戏',
              router: '/help/shakeGame',
            },
            {
              title: '划一划游戏',
              router: '/help/slideGame',
            },
          ],
        },
        {
          title: '手机遥控功能',
          subMenus: [
            {
              title: '手机遥控功能',
              router: '/help/mobileRemote',
            },
          ],
        },
      ],
    };
  },
  methods: {
    isActive(subMenu) {
      if (!subMenu.router) return false;
      return this.$route.path === subMenu.router;
    },
    handleSubMenuClick(subMenu) {
      if (subMenu.router) {
        this.$router.push(subMenu.router);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.side-menu {
  width: 260px;
  min-height: 350px;
  border: 1px solid #CC5DFB;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.main-menu-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.main-menu {
  width: 100%;
  height: 52px;
  background: linear-gradient(90deg, rgba(89, 0, 217, 0.7) 0%, rgba(167, 25, 228, 0.7) 100%);
  border: 1px solid #CC5DFB;
  padding-left: 58px;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.menu-title {
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-align: left;
}

.sub-menu {
  width: 100%;
  height: 52px;
  background: #000;
  padding-left: 58px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover,
  &.active {
    .sub-menu-title {
      color: #E19BFF;
    }
  }
}

.sub-menu-title {
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  text-align: left;
}
</style>
